import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

export const HistorySkeleton = () => (
  <div className="history-mobile-stack history-skeleton-stack d-block">
    {Array.from({ length: 3 }).map((_, index) => (
      <Card className="history-mobile-card skeleton-card" key={`history-skeleton-${index}`}>
        <Card.Body>
          <div className="skeleton-line skeleton-line-short mb-3" />
          <div className="mobile-route-card mb-3">
            <div className="skeleton-line skeleton-line-medium" />
            <div className="skeleton-circle" />
            <div className="skeleton-line skeleton-line-medium" />
          </div>
          <div className="skeleton-line mb-2" />
          <div className="d-flex justify-content-between align-items-center gap-3 mt-3">
            <div className="skeleton-line skeleton-line-short" />
            <div className="skeleton-pill" />
          </div>
        </Card.Body>
      </Card>
    ))}
  </div>
);

export const TrackingSkeleton = () => (
  <Row className="g-3 tracking-skeleton-grid">
    {Array.from({ length: 3 }).map((_, index) => (
      <Col md={6} lg={4} key={`tracking-skeleton-${index}`}>
        <Card className="tracking-card skeleton-card h-100">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div className="skeleton-line skeleton-line-short" />
              <div className="skeleton-circle" />
            </div>
            <div className="skeleton-pill mb-3" />
            <div className="skeleton-line mb-2" />
            <div className="skeleton-line mb-3" />
            <div className="skeleton-line mb-2" />
            <div className="skeleton-line skeleton-line-medium mb-3" />
            <div className="skeleton-button" />
          </Card.Body>
        </Card>
      </Col>
    ))}
  </Row>
);
